import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { languageFlags } from "../../../constant/Languages";
import { addFaq } from "../../../constant/string";
import services from "../../../services/services";
import InputComponent from "../../inputComponent/InputComponent";
import SelectComponent from "../../selectComponent/SelectComponent";
import DeleteModalComponent from "../modal/DeleteModalComponent";
import FaqEdit from "../modal/FaqEdit";
import {
  LanguageKey,
  validateMultilingualData,
} from "./FaqUtils";
import { LanguageSelect } from "../../multiSelect/LanguageSelect";

interface LanguageTextPair {
  language: string;
  text: string;
}

const TextLanguageViewComponent = React.memo(
  ({ data }: { data: string | Array<any> }) => {
    let parsedData: any[] = [];

    try {
      const raw = typeof data === "string" ? JSON.parse(data) : data;
      parsedData = Array.isArray(raw) ? raw : [];
    } catch (error) {
      console.error("Error parsing data:", error);
      parsedData = [];
    }

    return (
      <div className="flex flex-col gap-2">
        {parsedData?.map((item: any, index: number) => (
          <div key={index} className="flex flex-row gap-2">
            <div className="p-1 border border-aqua rounded-lg flex-1 justify-center items-center">
              {item.text}
            </div>
            <div className="p-1 border border-aqua rounded-lg justify-center items-center">
              {item.language
                ? languageFlags[item?.language as LanguageKey]?.name ||
                item.language
                : "Unknown"}
            </div>
          </div>
        ))}
      </div>
    );
  }
);

const FaqComponent = () => {
  //{ question:[{text:"",lang:""}],answer:[],filtername:[]}

  const [allFaq, setAllFaq] = useState([]);
  const [missingError, setMissingError] = useState(false);
  const { Tours } = useSelector((state: any) => state.tours);

  const getdata = async () => {
    try {
      const res = await services.getAllFaq();
      const resData = res?.data?.data;

      if (!resData) {
        console.error("No data received");
        return;
      }
      console.log("resdata")
      setAllFaq(resData);
    } catch (err) {
      console.error("Error fetching FAQ data", err);
    }
  };

  useEffect(() => {
    getdata();
  }, []);
  const handleAddFaqs = async (values: any) => {
    try {
      const language = values.language;
      const faq = {
        tourId: values.tourId,
        filterName: [{ text: values.filterName, language }],
        question: [{ text: values.question, language }],
        answer: [{ text: values.answer, language }] 
      }
      console.log("faQ: ", faq);
      const res = await services.postAddFaq(faq);
      if (res.status == 200) {
        formik.handleReset(values);
        getdata();
        toast.success(res?.data?.message);
      } else {
        toast.dismiss();
        toast.error("someThing Went Wrong");
      }
    } catch (error) {
      toast.dismiss();
      toast.error("someThing Went Wrong");
    }
  };
  const handleRemoveFaq = async (id: number) => {
    const res: any = await services.removeAddFaq(id);
    if (res.status === 200) {
      toast.success(res?.data.message);
      getdata();
    } else {
      toast.dismiss();
      toast.error("Something Went Wrong");
    }
  };
  // formik intrigation

  const formik = useFormik({
    initialValues: {
      language: "",
      question: "",
      answer: "",
      filterName: "",
      tourId: "",
    },
    validationSchema: Yup.object({
      tourId: Yup.string().trim().required("This field is required"),
      question: Yup.string().trim().required("Question is required"),
      language: Yup.string().trim().required("language is required"),
      answer: Yup.string().trim().required("Answer is required"),
      filterName: Yup.string().trim().required("filterName field is required"),
    }),
    onSubmit: (values) => {
      const { tourId, question, answer, filterName, language } = values;
      const isValid = !(!tourId || !question || !answer || !filterName || !language)
      console.log("isvalude: ", isValid)
      if (isValid) {
        handleAddFaqs(values);
        setMissingError(false);
      } else {
        setMissingError(true);
        console.error("Validation failed: Missing fields for some languages.");
      }
    },
  });

  return (
    <div>
      <form
        onSubmit={(e) => {
          e.preventDefault(); // Prevent default submission
          formik.handleSubmit();
        }}
        className="w-full  border border-aqua rounded-xl px-12 py-11"
      >
        <p className="font-bold font-openSans text-xl">FAQ's</p>
        <div className="w-full  mx-auto mt-8">
          {addFaq.map((elm: any) =>
            elm?.key == "option" ? (
              <SelectComponent
                id={elm?.name}
                landing={true}
                handlechange={(e: any) =>
                  formik.setFieldValue(elm?.name, e.target.value)
                }
                value={(formik as any)?.values?.[elm?.name]}
                name={elm?.name}
                label={elm?.label}
                placeholder={elm?.placeHolder}
                type={elm?.type}
                key={elm?.key1}
                error={(formik as any).errors[elm.name]}
                touched={(formik as any).touched[elm.name]}
                option={elm?.key1 == "tourId" ? Tours?.data?.data : elm?.option}
              />
            ) : elm?.name === 'language' ? 
                <LanguageSelect 
                  name={elm?.name}
                  label={elm?.label}
                  error={(formik as any).errors[elm.name]}
                  touched={(formik as any).touched[elm.name]}
                  handleSelectLang={(e: any) => formik.setFieldValue(elm?.name, e)}
                  value={(formik as any)?.values?.[elm?.name]}
                  /> 
                  : (<InputComponent
                  id={elm?.name}
                  handlechange={formik.handleChange}
                  accept={elm?.accept}
                  value={(formik as any)?.values?.[elm?.name]}
                  name={elm?.name}
                  label={elm?.label}
                  placeholder={elm?.placeHolder}
                  type={elm?.type}
                  error={(formik as any).errors[elm.name]}
                  touched={(formik as any).touched[elm.name]}
                  multiline={elm?.name == 'answer' ? true : false}
                />
              )
          )}
        </div>
        {missingError && (
          <p className=" text-red-500">
            Validation failed: Missing fields for some languages.
          </p>
        )}
        <button
          className="w-[200px] h-[50px] bg-aqua rounded  text-brown mt-10"
          type="submit"
        >
          Add
        </button>
      </form>
      <div className="w-full h-full border border-aqua rounded-xl  px-12 py-11 mt-2">
        <p className="font-bold font-openSans text-xl ">FAQ’s Added</p>
        {allFaq.map((eml: any) => (
          <div className=" w-full border-2   border-[#74A89F70]  rounded-md mt-10 px-8 py-6 'font-roboto text-xl text-[#616161]'">
            <div className="flex justify-end">
              <FaqEdit getdata={getdata} data={eml} />
              <DeleteModalComponent
                dlFn={() => {
                  handleRemoveFaq(eml?.id);
                }}
              />
            </div>
            {eml?.tourId == 0 ? (
              <h4 className="text-xl font-openSans font-bold text-black">
                For Landing
              </h4>
            ) : null}
            <div className="flex flex-col justify-between mt-4">
              <div className="border border-aqua rounded-xl p-2 mb-4">
                <h1 className=" font-bold mb-1">Filter Name</h1>
                <TextLanguageViewComponent data={eml.name} />
              </div>

              <div className="flex-col border border-aqua rounded-xl p-2 mb-4">
                <h1 className=" font-bold mb-1">Top Question</h1>
                <TextLanguageViewComponent data={eml.topQuestion} />
              </div>
              <div className="border border-aqua rounded-xl p-2">
                <h1 className=" font-bold mb-1">Answer</h1>
                <TextLanguageViewComponent data={eml.description} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqComponent;
